function importAll(r) {
    return r.keys().map(r);
}

const equipmentImages = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentText = [
    {
        name: `Large pan`,
        note: `cast iron works well`
    },
    {
        name: `Medium mixing bowl`
    }
]

export const equipment = equipmentText.map((item, index) => {
    return {
        name: item.name,
        note: item.note, 
        img: equipmentImages[index]
    }
})